import React, { Component } from 'react'
import { observer } from 'mobx-react'

import InvoiceDetails from './invoicedetails'

@observer(['quotes'])
export default class CreateQuote extends Component {
  constructor(props) {
    super(props)

  }

  saveQuote(quoteInfo, callback) {
    this.props.quotes.saveQuote(quoteInfo, (quote) => {
      if (callback != null) {
        callback(quote)
      }
    })
  }

  render() {
    return (
      <div>
        <InvoiceDetails type={ 'new' } companyId={ this.props.params.companyId } saveQuote={ this.saveQuote.bind(this) } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/company/createquote.js